import { render, staticRenderFns } from "./add-team-members.vue?vue&type=template&id=21d1068c&scoped=true&"
import script from "./add-team-members.vue?vue&type=script&lang=js&"
export * from "./add-team-members.vue?vue&type=script&lang=js&"
import style0 from "./add-team-members.vue?vue&type=style&index=0&id=21d1068c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d1068c",
  null
  
)

component.options.__file = "add-team-members.vue"
export default component.exports